import React from 'react';
import { useQuery, useMutation } from '@apollo/client/react';
import { useParams, useNavigate } from 'react-router-dom';
import { gql } from '@apollo/client';
import Breadcrumb from '../components/Breadcrumb';
import ResourceForm from '../components/ResourceForm';
import { UPDATE_USER } from '../graphql/mutations';
import { USERS_QUERY } from '../graphql/queries';

const USER_QUERY = gql`
  query User($id: ID!) {
    user(id: $id) {
      id
      name
      email
      role
      role
      disabled
    }
  }
`;

const FORM_FIELDS = [
  { key: 'name', label: 'Name', type: 'text', required: true },
  { key: 'email', label: 'Email', type: 'email', required: true },
  {
    key: 'role',
    label: 'Role',
    type: 'select',
    options: [
      { value: '0', label: 'User' },
      { value: '1', label: 'Admin' }
    ]
  },
  { key: 'disabled', label: 'Disabled', type: 'boolean' }
];

export default function UserFormPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data } = useQuery(USER_QUERY, { variables: { id }, skip: !id });

  const [updateUser, { loading }] = useMutation(UPDATE_USER, {
    refetchQueries: [{ query: USERS_QUERY }],
    awaitRefetchQueries: true
  });

  const user = data?.user;

  const handleSubmit = async (formState) => {
    try {
      await updateUser({
        variables: {
          input: {
            id,
            name: formState.name,
            email: formState.email,
            role: parseInt(formState.role),
            disabled: formState.disabled
          }
        }
      });
      navigate('/users');
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div className="page-content">
      <Breadcrumb items={[{ label: 'Users', link: '/users' }, { label: 'Edit User' }]} />
      <ResourceForm
        resource={user ? { ...user, type: 'User' } : null}
        fields={FORM_FIELDS}
        onSubmit={handleSubmit}
        onCancel={() => navigate(-1)}
        loading={loading}
        submitLabel="Update User"
      />
    </div>
  );
}
